module.exports = __webpack_public_path__ + "static/media/natwest-white.140b3ee1.svg";